/**
 * The origin to put in a link a *client* will open.
 *
 * In a browser that is simply where the app is served from. In the desktop app
 * it is not: the renderer runs on `app://photentra`, an origin that exists only
 * inside Electron. Building a share link or a QR code from `window.location`
 * there produces `app://photentra/shared/abc` — which does nothing on the
 * client's phone, and nothing when scanned.
 *
 * The API's own origin is the public web origin (the API serves the frontend in
 * production), so the desktop derives the answer from the base URL its preload
 * injected.
 */
export default function publicOrigin() {
	if (typeof window === "undefined") return "";

	const origin = window.location.origin;
	// Browser (and desktop dev mode, which loads from the CRA dev server).
	if (!origin.startsWith("app:")) return origin;

	const apiBase = window.photentra?.apiBaseUrl || "";
	if (/^https?:\/\//i.test(apiBase)) {
		try {
			return new URL(apiBase).origin;
		} catch {
			/* fall through to the production default */
		}
	}
	return "https://photentra.com";
}

/** Convenience for the common `${publicOrigin()}${path}` shape. */
export function publicUrl(path = "") {
	return `${publicOrigin()}${path.startsWith("/") ? path : `/${path}`}`;
}
